export default __webpack_public_path__ + "static/media/userhackathons.7170157f.svg";